/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Strava_WaitingInputs */

const en_us2_native_release_strava_waiting = /** @type {(inputs: Native_Release_Strava_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish connecting in the browser, then come back to the app.`)
};

const pt_br2_native_release_strava_waiting = /** @type {(inputs: Native_Release_Strava_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine a conexão no navegador e volte ao app.`)
};

const pt_pt2_native_release_strava_waiting = /** @type {(inputs: Native_Release_Strava_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine a conexão no navegador e volte ao app.`)
};

/** @type {(inputs: Native_Release_Strava_WaitingInputs) => LocalizedString} */
const es_419_native_release_strava_waiting = en_us2_native_release_strava_waiting;

/** @type {(inputs: Native_Release_Strava_WaitingInputs) => LocalizedString} */
const fr_fr2_native_release_strava_waiting = en_us2_native_release_strava_waiting;

/** @type {(inputs: Native_Release_Strava_WaitingInputs) => LocalizedString} */
const de_de2_native_release_strava_waiting = en_us2_native_release_strava_waiting;

/** @type {(inputs: Native_Release_Strava_WaitingInputs) => LocalizedString} */
const it_it2_native_release_strava_waiting = en_us2_native_release_strava_waiting;

/**
* | output |
* | --- |
* | "Finish connecting in the browser, then come back to the app." |
*
* @param {Native_Release_Strava_WaitingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_strava_waiting = /** @type {((inputs?: Native_Release_Strava_WaitingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Strava_WaitingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_strava_waiting(inputs)
	if (locale === "es-419") return es_419_native_release_strava_waiting(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_strava_waiting(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_strava_waiting(inputs)
	if (locale === "de-DE") return de_de2_native_release_strava_waiting(inputs)
	if (locale === "it-IT") return it_it2_native_release_strava_waiting(inputs)
	return en_us2_native_release_strava_waiting(inputs)
});
export { native_release_strava_waiting as "native-release.strava_waiting" }